import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _debounce from "lodash/debounce";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useEffect, useMemo, useRef, useState } from 'react';
import classnames from 'classnames';
import { StatusMessage } from "../../Messaging/StatusMessage/StatusMessage";
import { TextInput } from "../TextInput/TextInput";
import { InputGroup } from "../InputGroup/InputGroup";
import { usePrevious } from "../../Utility/Hooks";
import styles from "./ValidatedInput.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ValidatedInput = function ValidatedInput(_ref) {
  var _ref$arrowButton = _ref.arrowButton,
    arrowButton = _ref$arrowButton === void 0 ? false : _ref$arrowButton,
    _ref$autoFocus = _ref.autoFocus,
    autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
    _ref$buttonAttributes = _ref.buttonAttributes,
    buttonAttributes = _ref$buttonAttributes === void 0 ? {} : _ref$buttonAttributes,
    _ref$buttonClassName = _ref.buttonClassName,
    buttonClassName = _ref$buttonClassName === void 0 ? classnames(styles.button, styles.validatedInputButton) : _ref$buttonClassName,
    _ref$buttonText = _ref.buttonText,
    buttonText = _ref$buttonText === void 0 ? '' : _ref$buttonText,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$errorMessage = _ref.errorMessage,
    errorMessage = _ref$errorMessage === void 0 ? '' : _ref$errorMessage,
    _ref$hasButton = _ref.hasButton,
    hasButton = _ref$hasButton === void 0 ? true : _ref$hasButton,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? '' : _ref$id,
    _ref$inputClassName = _ref.inputClassName,
    inputClassName = _ref$inputClassName === void 0 ? '' : _ref$inputClassName,
    _ref$inputAttributes = _ref.inputAttributes,
    inputAttributes = _ref$inputAttributes === void 0 ? {} : _ref$inputAttributes,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    _ref$onChangeText = _ref.onChangeText,
    onChangeTextInit = _ref$onChangeText === void 0 ? function () {} : _ref$onChangeText,
    _ref$onSubmit = _ref.onSubmit,
    onSubmitInit = _ref$onSubmit === void 0 ? function () {} : _ref$onSubmit,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? '' : _ref$placeholder,
    regex = _ref.regex,
    regexErrorMessage = _ref.regexErrorMessage,
    _ref$small = _ref.small,
    small = _ref$small === void 0 ? false : _ref$small,
    _ref$statusMessageCla = _ref.statusMessageClassName,
    statusMessageClassName = _ref$statusMessageCla === void 0 ? '' : _ref$statusMessageCla,
    _ref$statusMessageTyp = _ref.statusMessageTypog,
    statusMessageTypog = _ref$statusMessageTyp === void 0 ? 'caption' : _ref$statusMessageTyp,
    _ref$text = _ref.text,
    initText = _ref$text === void 0 ? '' : _ref$text,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'default' : _ref$variant;
  var dirty = useRef(false);
  var _useState = useState(initText),
    _useState2 = _slicedToArray(_useState, 2),
    text = _useState2[0],
    setText = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  var prevErrorMessage = usePrevious(errorMessage);
  var updateText = useMemo(function () {
    return _debounce(function (newText) {
      if (newText.length) {
        dirty.current = true;
      } else {
        dirty.current = false;
      }
      setText(newText);
      setError(false);
      onChangeTextInit(newText);
    }, 500);
  }, [onChangeTextInit]);
  var onChangeText = function onChangeText(newText) {
    updateText(newText);
  };
  var onSubmit = function onSubmit(newText) {
    dirty.current = true;
    if (regex.test(newText)) {
      onSubmitInit(newText);
    }
  };
  useEffect(function () {
    var display = !dirty.current && text.length === 0 || regex.test(text);

    // If errorMessage is changed, update right away.
    if (errorMessage !== prevErrorMessage) {
      setError(!display || !!errorMessage);
    }

    // Set any text-entry regex errors through a throttling timeout.
    var timeoutID = setTimeout(function () {
      setError(!display || !!errorMessage);
    }, 750);
    return function () {
      clearTimeout(timeoutID);
    };
  }, [prevErrorMessage, errorMessage, regex, text]);
  var inputOtherProps = {
    arrowButton: arrowButton,
    autoFocus: autoFocus,
    buttonAttributes: buttonAttributes,
    buttonClassName: buttonClassName,
    buttonText: buttonText,
    inputAttributes: inputAttributes,
    inputClassName: inputClassName,
    loading: loading,
    placeholder: placeholder,
    small: small,
    variant: variant
  };
  var InputComponent = hasButton ? InputGroup : TextInput;
  return /*#__PURE__*/_jsxs("div", {
    className: classnames(className, styles.validatedInput),
    children: [/*#__PURE__*/_jsx(InputComponent, _objectSpread({
      id: id,
      onSubmit: onSubmit,
      onChangeText: onChangeText,
      hasError: error,
      text: text
    }, inputOtherProps)), error && /*#__PURE__*/_jsx(StatusMessage, {
      className: statusMessageClassName,
      typog: statusMessageTypog,
      children: errorMessage || regexErrorMessage
    })]
  });
};